/*
 * ALOHA QUEEN SUPERNOVA - Animated Title Component
 * Copyright © 2025 Malcolm KH Lee III. All Rights Reserved.
 */

import React from 'react';

const AnimatedTitle = ({ children, className = '' }) => {
  return (
    <h1 className={`relative inline-block ${className}`}>
      {/* Glowing background */}
      <span className="absolute inset-0 blur-2xl bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-500 animate-pulse opacity-50" />
      
      {/* Main text with gradient */}
      <span className="relative bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-400 bg-clip-text text-transparent font-bold animate-gradient">
        {children}
      </span>
      
      {/* Sparkle effects */}
      <span className="absolute top-0 right-0 w-2 h-2 bg-yellow-300 rounded-full animate-ping" style={{ animationDuration: '2s' }} />
      <span className="absolute bottom-0 left-1/4 w-1.5 h-1.5 bg-pink-400 rounded-full animate-ping" style={{ animationDelay: '1s', animationDuration: '2s' }} />
      <span className="absolute top-1/2 right-1/4 w-1 h-1 bg-purple-300 rounded-full animate-ping" style={{ animationDelay: '0.5s', animationDuration: '2s' }} />
    </h1>
  );
};

export default AnimatedTitle;